import {setConfirmInfo, useUiStore} from "@/stores/ui-store";
import {ConfirmDialog} from "@/components/app";

const GlobalConfirm = () => {
  const confirmInfo = useUiStore(state => state.confirmInfo);
  if (!confirmInfo || !confirmInfo.message || !confirmInfo.onConfirm) {
    return null;
  }
  const onCancel = () => {
    setConfirmInfo(null);
  };
  const onConfirm = async () => {
    let res: void | boolean = true;
    if (typeof confirmInfo.onConfirm === 'function') {
      res = await confirmInfo.onConfirm(confirmInfo.payload);
    }
    if (res !== false) {
      setConfirmInfo(null);
    }
  }
  return (
    <ConfirmDialog onConfirm={onConfirm} title={confirmInfo.title} onCancel={onCancel}>
      {confirmInfo.message}
    </ConfirmDialog>
  );
};

export default GlobalConfirm;